import { storefrontDeliveryEstimateSchema } from "@redotech/redo-model/conversion/storefront-delivery-estimate";
import * as z from "zod/v4";

export const updateStorefrontDeliveryEstimateSettings = {
  name: "updateStorefrontDeliveryEstimateSettings" as const,
  input: z.object({ settings: storefrontDeliveryEstimateSchema }),
  output: z.null(),
};
